/**
 * Custom language detection, just returns the config property if any.
 */
export default {
    /**
     * Does not support caching.
     *
     * @returns {void}
     */
    cacheUserLanguage: Function.prototype,
    /**
     * Looks the language up in the config.
     *
     * @returns {string} The default language if any.
     */
    lookup() {
        // Force French language as fallback
        return config?.defaultLanguage || 'fr';
    },
    /**
     * Name of the language detector.
     */
    name: 'configLanguageDetector'
};
